if (!customElements.get('gem-shop')) {
  customElements.define('gem-shop', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const opts = { signal: this.controller.signal };
      const dialog = this.querySelector('dialog');
      const openButton = this.querySelector('[data-open-finder]');
      const need = this.querySelector('select[data-need]');
      const ranges = this.querySelector('[data-range-controls]');
      const result = this.querySelector('[data-recommendation]');
      const compare = this.querySelector('.gs-compare');
      const templates = [...this.querySelectorAll('template[data-recommendation-template]')];
      const cards = [...this.querySelectorAll('[data-kit-card]')];
      const update = () => {
        const useRange = ['surface', 'module'].includes(need.value);
        ranges.hidden = !useRange;
        const range = this.querySelector('input[type="radio"]:checked').value;
        const match = templates.find(t => t.dataset.need === need.value && (!useRange || t.dataset.range === range));
        result.replaceChildren((match || this.querySelector('template[data-no-match]')).content.cloneNode(true));
      };
      const close = () => dialog.close();
      const showCompare = () => {
        compare.open = true;
        compare.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        compare.querySelector('summary').focus({ preventScroll: true });
      };
      if (typeof dialog.showModal === 'function') {
        openButton.hidden = false;
        const openFinder = () => { update(); if (!dialog.open) dialog.showModal(); need.focus(); };
        openButton.addEventListener('click', openFinder, opts);
        if (new URLSearchParams(window.location.search).get('choose') === '1') openFinder();
      }
      this.querySelector('[data-close-finder]').addEventListener('click', close, opts);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      }, opts);
      need.addEventListener('change', update, opts);
      ranges.addEventListener('change', update, opts);
      this.querySelector('[data-compare-from-finder]').addEventListener('click', () => { close(); showCompare(); }, opts);
      this.querySelector('[data-open-compare]').addEventListener('click', event => { event.preventDefault(); showCompare(); }, opts);
      this.querySelector('.gs-filters').hidden = false;
      this.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
        const filter = button.dataset.filter;
        this.querySelectorAll('[data-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        cards.forEach(card => { card.hidden = filter !== 'all' && card.dataset.category !== filter; });
        const count = cards.filter(c => !c.hidden).length;
        this.querySelector('[data-result-count]').textContent = String(count);
        this.querySelector('[data-filter-empty]').hidden = count !== 0;
      }, opts));
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
